<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px' }"
  [header]="'IMPORT_DATA' | translate"
  (onHide)="closeImportModal()">

  @if (fileFormatErrorKey) {
    <div class="import-validation-banner import-validation-banner--error" role="alert">
      <i class="pi pi-times-circle"></i>
      <div class="import-validation-banner__body">
        <span class="import-validation-banner__title">{{ fileFormatErrorKey | translate }}</span>
      </div>
    </div>
  }

  @if (validationSummaryKey || validationErrors.length > 0) {
    <div class="import-validation-list" role="alert">
      @if (validationSummaryKey) {
        <div class="import-validation-banner import-validation-banner--error">
          <i class="pi pi-exclamation-triangle"></i>
          <div class="import-validation-banner__body">
            <span class="import-validation-banner__title">
              {{ validationSummaryKey | translate: validationSummaryParams }}
            </span>
          </div>
        </div>
      }

      @for (err of validationErrors; track err.code) {
        <div
          class="import-validation-banner import-validation-banner--error"
          [attr.title]="err.rawMessage || null">
          <i class="pi pi-ban"></i>
          <div class="import-validation-banner__body">
            <span class="import-validation-banner__title">{{ err.messageKey | translate }}</span>
          </div>
        </div>
      }
    </div>
  }

  <app-file-upload
    title="{{'File upload' | translate}} (GeoJSON, KML, Shapefile)"
    [multiple]="true"
    [accept]="'.geojson, .json, .kml, .shp, .zip'"
    (filesSelected)="onFileSelected($event)"
    (fileRemoved)="onFileRemoved($event)">
  </app-file-upload>

  <div class="field-group mt-4 align-items-start flex flex-column">
    <label>{{ 'Comment' | translate }}</label>
    <app-textarea
      class="mt-2"
      placeholder="{{ 'Fields comment' | translate }}"
      [(ngModel)]="formData.comment"
    ></app-textarea>
  </div>

  <div class="import-actions flex flex-row-reverse gap-2 mt-2">
    <app-secondary-button
      [title]="'CANCEL'"
      (action)="closeImportModal()"
    ></app-secondary-button>

    <app-primary-button
      [title]="'IMPORT'"
      [loading]="isImporting"
      [disable]="(!selectedImportFiles || selectedImportFiles.length === 0) || isImporting"
      (action)="performImport()"
    ></app-primary-button>
  </div>

</p-dialog>
